import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { Surgery } from '../../core/models/surgery.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';

export class AssignedSurgeriesTableConfigBuilder extends TableConfigBuilder<Surgery> {
  private isViewOnlyMode: boolean = false;

  private scheduleSurgeryFunc:
    | ((item?: Surgery, event?: any) => void)
    | undefined;

  private reScheduleSurgeryFunc:
    | ((item?: Surgery, event?: any) => void)
    | undefined;

  private surgeryStatusNameFunc: ((item?: Surgery) => string) | undefined;

  private cancelSurgeryFunc:
    | ((item?: Surgery, event?: any) => void)
    | undefined;

  private completeSurgeryFunc:
    | ((item?: Surgery, event?: any) => void)
    | undefined;

  private viewSurgeryFunc: ((item?: Surgery, event?: any) => void) | undefined;

  private isScheduleSurgeryBtnVisibleFunc:
    | ((item?: Surgery) => boolean)
    | undefined;

  private isReScheduleSurgeryBtnVisibleFunc:
    | ((item?: Surgery) => boolean)
    | undefined;

  private isCancelSurgeryBtnVisibleFunc:
    | ((item?: Surgery) => boolean)
    | undefined;

  private isCompleteSurgeryBtnVisibleFunc:
    | ((item?: Surgery) => boolean)
    | undefined;

  setIsViewOnly(isViewOnly: boolean): AssignedSurgeriesTableConfigBuilder {
    this.isViewOnlyMode = isViewOnly;
    return this;
  }

  getColumns() {
    const allColumns = [
      new TextColumn({
        name: 'Μον. κωδικός ΕΛΧ',
        propertyName: 'uniqueListPatientCode',
      }),
      new TextColumn({
        name: 'Voucher',
        propertyName: 'surgeryCode',
      }),
      ...(!this.isViewOnlyMode ? [new TextColumn({
        name: 'ΑΜΚΑ',
        propertyName: 'patientAmka',
      })] : []),
      new TextColumn({
        name: 'Κλινική',
        propertyName: 'clinicName',
      }),
      new TextColumn({
        name: 'Τύπος',
        propertyName: 'surgeryType',
      }),
      new DateColumn({
        name: 'Ημ. κλινικής εκτίμησης',
        propertyName: 'examinationDate',
      }),
      new DateColumn({
        name: 'Ημ. εισαγωγής στην ΕΛΧ',
        propertyName: 'listEntryDate',
      }),
      new TextColumn({
        name: 'Μήνας ανάθεσης',
        propertyName: 'assignmentMonth',
      }),
      new DateColumn({
        name: 'Ημ. ανάθεσης',
        propertyName: 'assignmentDate',
      }),
      new DateColumn({
        name: 'Ημ. χειρουργείου',
        propertyName: 'surgeryDate',
      }),
      new TextColumn({
        name: 'Κατάσταση',
        propertyName: 'surgeryStatusName',
        tooltip: (item?: Surgery) => {
          if (this.surgeryStatusNameFunc) {
            return this.surgeryStatusNameFunc(item);
          }
          return '';
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-eye p-info',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Προβολή',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.viewSurgeryFunc) {
            this.viewSurgeryFunc(item, event);
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-calendar-plus p-success',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Προγραμματισμός',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.scheduleSurgeryFunc) {
            this.scheduleSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          if (this.isScheduleSurgeryBtnVisibleFunc) {
            return this.isScheduleSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-calendar-plus p-warning',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Επαναπρογραμματισμός',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.reScheduleSurgeryFunc) {
            this.reScheduleSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          if (this.isReScheduleSurgeryBtnVisibleFunc) {
            return this.isReScheduleSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-times-circle p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Ακύρωση',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.cancelSurgeryFunc) {
            this.cancelSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          if (this.isCancelSurgeryBtnVisibleFunc) {
            return this.isCancelSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-check-square p-success',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Ολοκλήρωση',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.completeSurgeryFunc) {
            this.completeSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          if (this.isCompleteSurgeryBtnVisibleFunc) {
            return this.isCompleteSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
    ];

    return allColumns;
  }

  addIsScheduleSurgeryBtnVisibleFunction(
    isScheduleSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): AssignedSurgeriesTableConfigBuilder {
    this.isScheduleSurgeryBtnVisibleFunc = isScheduleSurgeryBtnVisibleFunc;
    return this;
  }

  addIsReScheduleSurgeryBtnVisibleFunction(
    isReScheduleSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): AssignedSurgeriesTableConfigBuilder {
    this.isReScheduleSurgeryBtnVisibleFunc = isReScheduleSurgeryBtnVisibleFunc;
    return this;
  }

  addScheduleSurgeryFunction(
    scheduleSurgeryFunc: (item?: Surgery, event?: any) => void
  ): AssignedSurgeriesTableConfigBuilder {
    this.scheduleSurgeryFunc = scheduleSurgeryFunc;
    return this;
  }

  addReScheduleSurgeryFunction(
    reScheduleSurgeryFunc: (item?: Surgery, event?: any) => void
  ): AssignedSurgeriesTableConfigBuilder {
    this.reScheduleSurgeryFunc = reScheduleSurgeryFunc;
    return this;
  }

  addSurgeryStatusNameFunction(
    surgeryStatusNameFunc: (item?: Surgery) => string
  ): AssignedSurgeriesTableConfigBuilder {
    this.surgeryStatusNameFunc = surgeryStatusNameFunc;
    return this;
  }

  addIsCancelSurgeryBtnVisibleFunction(
    isCancelSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): AssignedSurgeriesTableConfigBuilder {
    this.isCancelSurgeryBtnVisibleFunc = isCancelSurgeryBtnVisibleFunc;
    return this;
  }

  addCancelSurgeryFunction(
    cancelSurgeryFunc: (item?: Surgery, event?: any) => void
  ): AssignedSurgeriesTableConfigBuilder {
    this.cancelSurgeryFunc = cancelSurgeryFunc;
    return this;
  }

  addIsCompleteSurgeryBtnVisibleFunction(
    isCompleteSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): AssignedSurgeriesTableConfigBuilder {
    this.isCompleteSurgeryBtnVisibleFunc = isCompleteSurgeryBtnVisibleFunc;
    return this;
  }

  addCompleteSurgeryFunction(
    completeSurgeryFunc: (item?: Surgery, event?: any) => void
  ): AssignedSurgeriesTableConfigBuilder {
    this.completeSurgeryFunc = completeSurgeryFunc;
    return this;
  }

  addViewSurgeryFunction(
    viewSurgeryFunc: (item?: Surgery, event?: any) => void
  ): AssignedSurgeriesTableConfigBuilder {
    this.viewSurgeryFunc = viewSurgeryFunc;
    return this;
  }

  getTable(data: Surgery[]): TableConfig<Surgery> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }
}
